module.exports = __webpack_public_path__ + "img/portraits_06_V.2ff45813.webp";